<!-- eslint-disable vue/no-parsing-error -->
<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col cols="12" xl="4" class="d-flex justify-content-between flex-column">
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex flex-column ml-1">
          <div class="mb-1">
            <div class="d-flex justify-content-between">
              <h4 class="mb-0" style="text-transform: capitalize">
                {{ userData.fullName }}
              </h4>
            </div>
            <p style="margin: 0; margin-top: 5px;">
              <feather-icon icon="MailIcon" class="mr-75" />
              {{ userData.email }}
            </p>
            <p style="margin: 0; margin-top: 5px;">
              <feather-icon icon="PhoneIcon" class="mr-75" />
              {{ userData.mobile }}
            </p>
          </div>
        </div>
        <b-col v-if="!userData.confirmed" cols="12">
          <b-row>
            <b-button v-b-modal.send-message-modal variant="outline-primary" class="mt-1" style="width: 200px">
              {{ $t('application.personalInfo.btn.sendMessage') }}
            </b-button>
          </b-row>
          <b-row>
            <b-button v-b-modal.send-sms-modal variant="outline-primary" class="mt-1" style="width: 200px">
              {{ $t('application.personalInfo.btn.sendSMS') }}
            </b-button>
          </b-row>
          <b-row>
            <b-button v-if="userData.love" v-b-modal.change-status-love-modal variant="outline-warning" class="mt-1" style="width: 200px">
              {{ $t('application.personalInfo.btn.notHavingLove') }}
            </b-button>
          </b-row>
        </b-col>
      </b-col>

      <!-- Right Col: Table -->
      <b-col cols="12" xl="4">
        <table class="mt-4 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold" style="margin-right: 10px;">{{ $t(userData.birthday.length < 5 ? 'birthYear' : 'birthday') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.birthday }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('profession') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.profession }}
            </td>
          </tr>
          <tr v-if="userData.profession == 'opiskelija'">
            <th class="pb-50">
              <span class="font-weight-bold" />
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.studies.studyType }}
            </td>
          </tr>
          <tr v-if="userData.profession == 'opiskelija'">
            <th class="pb-50">
              <span class="font-weight-bold" />
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.studies.credits }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('finnish') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.finnish }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('languages') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.languages ? userData.languages.join(', ') : '' }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('address') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ getAddress(userData.address) }}
            </td>
          </tr>
        </table>
      </b-col>
      <b-col cols="12" xl="4">
        <table class="mt-2 mt-xl-0 w-100">
          <tr v-if="appConfig.type === 'hw-admin'">
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('love') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.love ? 'Kyllä' : 'Ei' }}
            </td>
          </tr>
          <tr v-if="appConfig.type === 'hw-admin'">
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('permits') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.permits ? userData.permits.join(', ') : '' }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{ $t('car_available') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.carAvailable ? 'Kyllä' : 'Ei' }}
            </td>
          </tr>
          <tr>
            <th>
              <span class="font-weight-bold">{{ $t('driving_license') }}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.drivingLicense ? userData.drivingLicense.join(', ') : '' }}
            </td>
          </tr>
        </table>
      </b-col>
      <template v-if="userData.application && userData.application.seeking && userData.application.seeking.length > 0">
        <b-col cols="12" xl="4" offset="4">
          <table class="mt-2 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">Seeking</span>
              </th>
              <td class="pb-50 text-capitalize">
                {{ seeking }}
              </td>
            </tr>
          </table>
        </b-col>
        <b-col cols="12" xl="4">
          <table class="mt-2 mt-xl-0 w-100">
            <tr v-if="userData.application && userData.application.start">
              <th class="pb-50 text-capitalize">
                <span class="font-weight-bold">Start</span>
                <span>
                  {{
                    moment(userData.application.start.toDate())
                      .tz('Europe/Helsinki')
                      .format('DD.MM.YYYY')
                  }}
                </span>
                <template v-if="userData.application.end">
                  -
                  <span class="font-weight-bold">End</span>
                  <span>
                    {{
                      moment(userData.application.end.toDate())
                        .tz('Europe/Helsinki')
                        .format('DD.MM.YYYY')
                    }}
                  </span>
                </template>
              </th>
            </tr>
          </table>
        </b-col>
      </template>
    </b-row>
    <b-row>
    </b-row>
    <send-message-modal :user-data="userData" @send-message="onSendMessage" />

    <send-SMS-modal :user-data="userData" @send-sms="onSendSMS" />

    <b-modal id="change-status-love-modal" :title="$t('application.lovenModal.title')" ok-variant="warning" @ok="changeStatusLove">
      <p class="mt-1 d-flex justify-content-between">
        <span>
          {{ $t('application.lovenModal.content') }}
        </span>
      </p>
    </b-modal>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BButton } from 'bootstrap-vue'
import { avatarText } from '@hw-ui/utils/filter'
import _ from 'lodash'
import * as moment from 'moment'
import 'moment-timezone'
import useApplicationsList from '../applications-list/useApplicationsList'
import SendMessageModal from './SendMessageModal.vue'
import SendSMSModal from './SendSMSModal.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    SendMessageModal,
    SendSMSModal,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      accepting: false,
      interviewing: false,
      processer: {},
    }
  },
  computed: {
    seeking() {
      return _.join(
        _.map(this.userData.application.seeking, item => _.startCase(item)),
        ', '
      )
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      this.processer = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      }
    })
  },
  methods: {
    moment,
    getAddress(address) {
      let str = ''
      str = `${address.streetAddress}, ${address.postcode} ${address.city} ${address.state}`
      return str
    },

    onSendMessage({ to, subject, message }) {
      this.$emit('action', 'send_message', {
        duration: 0,
        content: {
          message,
          to,
          subject,
        },
      })
    },

    onSendSMS({ body }) {
      this.$emit('action', 'send_sms', {
        duration: 0,
        content: {
          message: body,
        },
      })
    },

    changeStatusLove() {
      const message = `<p>Hei ${this.userData.firstName},</p>
      <p>Kiitos hakemuksestasi, hyväksyimme hakemuksesi mutta asetimme tilisi lääkehoitoluvattomaksi. Tämä tarkoittaa sitä että et pysty varaamaan luvallisia vuoroja. Jotta voisimme muutta tilisi luvalliseksi, tarvitsemme sinulta seuraavat asiakirjat:</p>
      <ul>
        <li><b>Lääkehoitolupa (teoria ja näytöt)</b></li>
      </ul>
      <p>Voit lähettää listatut asiakirjat liitteenä liitteet@hoiwa.fi, otsikolla: <b>Minun lääkelupani</b></p>
      <p>Ystävällisin terveisin,</p>
      <p>Hoiwa - tiimi</p>`
      this.$emit('action', 'change_status_love', {
        duration: 0,
        content: {
          love: false,
          to: this.userData.email,
          subject: 'Lääkehoitolupa puuttuu',
          message,
        },
      })
    },
  },
  setup() {
    const { resolveUserRoleVariant } = useApplicationsList()
    return {
      avatarText,
      resolveUserRoleVariant,
    }
  },
}
</script>

<style></style>
